'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../base-component.types';

import styles from './Resource.module.scss';

type ResourceProps = BaseComponentProps & {
  children: ReactNode;
};

/**
 * What a resource is laid out in — a question, an answer, an assessment step, an
 * image: a `ResourceBar` over each edge and a `ResourceBody` filling the space, with
 * the bars floating above rather than taking room from it.
 */
function Resource({ style, className, children, testId }: ResourceProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export { Resource };
